import { createContext, useContext, useReducer } from "react";
import { reducer } from "./reducer";

export const LoginContext = createContext({});

export function useLoginContext() {
  return useContext(LoginContext);
}

const initialState = {
  isLoading: false,
  message: "",
  isLogin: false,
};

export function LoginProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <LoginContext.Provider value={[state, dispatch]}>
      {children}
    </LoginContext.Provider>
  );
}
